export const QUESTIONS_REQUEST = 'QUESTIONS_REQUEST';
export const QUESTIONS_SUCCESS = 'QUESTIONS_SUCCESS';
export const QUESTIONS_APPEND = 'QUESTIONS_APPEND';
export const QUESTIONS_LOADING_MORE = 'QUESTIONS_LOADING_MORE';
export const QUESTIONS_FAIL = 'QUESTIONS_FAIL';

export const VOTE_REQUEST = 'VOTE_REQUEST';
export const VOTE_SUCCESS = 'VOTE_SUCCESS';
export const VOTE_FAIL = 'VOTE_FAIL';

export const COMMENTS_REQUEST = 'COMMENTS_REQUEST';
export const COMMENTS_SUCCESS = 'COMMENTS_SUCCESS';
export const COMMENTS_FAIL = 'COMMENTS_FAIL';

export const COMMENT_CREATE_REQUEST = 'COMMENT_CREATE_REQUEST';
export const COMMENT_CREATE_SUCCESS = 'COMMENT_CREATE_SUCCESS';
export const COMMENT_CREATE_FAIL = 'COMMENT_CREATE_FAIL';

export const COMMENT_LIKE_SUCCESS = 'COMMENT_LIKE_SUCCESS';
export const COMMENT_REPLY_SUCCESS = 'COMMENT_REPLY_SUCCESS';
export const COMMENTS_RESET = 'COMMENTS_RESET';

export const QUESTION_SINGLE_SUCCESS = 'QUESTION_SINGLE_SUCCESS';

export const QUESTION_CREATE_REQUEST = 'QUESTION_CREATE_REQUEST';
export const QUESTION_CREATE_SUCCESS = 'QUESTION_CREATE_SUCCESS';
export const QUESTION_CREATE_FAIL = 'QUESTION_CREATE_FAIL';

export const QUESTION_DELETE_SUCCESS = 'QUESTION_DELETE_SUCCESS';
export const COMMENT_DELETE_SUCCESS = 'COMMENT_DELETE_SUCCESS';

export const FOLLOW_TOGGLE_SUCCESS = 'FOLLOW_TOGGLE_SUCCESS';

export const QUESTION_PATCH = 'QUESTION_PATCH';
